import { GenericSchedule } from 'domains/tfDomain';
import { RootModel } from 'models';
import { TimeframeConfig } from 'domains/tfDomain';
import { createModel } from '@rematch/core';
import { baseReducers, BaseState } from './baseReducers';
import orgService from 'services/orgService';
import platformEqptService from 'services/eqptService';

interface TimeframeState extends BaseState {
  tfConfig?: TimeframeConfig;
  curItem?: GenericSchedule;
}

export const tf = createModel<RootModel>()({
  state: {
    tfConfig: undefined,
  } as TimeframeState,
  reducers: {
    ...baseReducers<TimeframeState>(),
  },
  effects: (dispatch) => {
    const { tf } = dispatch;
    return {
      async getOrgTimeframeConfig(orgId: number): Promise<void> {
        const data = await orgService.getTimeframeConfig(orgId);
        if (data.defaultTurnaroundTimes === null) {
          data.defaultTurnaroundTimes = [];
        }
        if (data.exceptionTurnaroundTimes === null) {
          data.exceptionTurnaroundTimes = [];
        }
        tf.setState({ tfConfig: data });
      },

      async saveSchedule(schedule: GenericSchedule, rootState): Promise<void> {
        if (schedule.parentType === 'eqpt') {
          if (schedule.id) {
            await platformEqptService.updateSchedule(schedule.parentId, {
              ...schedule,
              equipmentId: schedule.parentId,
            });
          } else {
            await platformEqptService.createSchedule(schedule.parentId, {
              ...schedule,
              equipmentId: schedule.parentId,
            });
          }
          await dispatch.eqpt.getList({
            page: {
              currentPage: rootState.eqpt.currentPage,
              pageSize: rootState.eqpt.pageSize,
            },
            query: {
              ...rootState.eqpt.filterObj,
            },
          });
        } else if (schedule.parentType === 'org') {
          if (schedule.id) {
            await orgService.updateSchedule(schedule.parentId, {
              ...schedule,
              orgId: schedule.parentId,
            });
          } else {
            await orgService.createSchedule(schedule.parentId, {
              ...schedule,
              orgId: schedule.parentId,
            });
          }
          dispatch.tf.getOrgTimeframeConfig(schedule.parentId);
        }
      },

      async removeSchedule(
        schedule: GenericSchedule,
        rootState
      ): Promise<void> {
        if (schedule.parentType === 'eqpt') {
          await platformEqptService.removeSchedule(
            schedule.parentId,
            schedule.id!
          );
          await dispatch.eqpt.getList({
            page: {
              currentPage: rootState.eqpt.currentPage,
              pageSize: rootState.eqpt.pageSize,
            },
            query: {
              ...rootState.eqpt.filterObj,
            },
          });
        } else if (schedule.parentType === 'org') {
          await orgService.removeSchedule(schedule.parentId, schedule.id!);
          dispatch.tf.getOrgTimeframeConfig(schedule.parentId);
        }
      },
    };
  },
});
